import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { MainService } from 'src/app/services/main.service'

import { NavTabGroup } from './nav-tab-group.model'

const profileIndex = 0

@Injectable({
  providedIn: 'root',
})
export class NavTabGroupService {
  navTabGroupModel = {} as NavTabGroup
  navTabGroupModel$: Observable<NavTabGroup>

  constructor(private readonly mainService: MainService) {}

  /*eslint complexity: [2, 10] */
  getModelData(): Observable<NavTabGroup> {
    return new Observable((subscriber) => {
      this.mainService
        .getNavTabGroupObservable()
        .pipe(take(1))
        .subscribe((ovObs) => {
          if (
            Object.keys(ovObs).length !== 0 &&
            ovObs[0]?.name !== 'HTTPError'
          ) {
            const profilePos = ovObs[profileIndex]?.fundProfile

            this.navTabGroupModel = {
              is529: profilePos?.is529,
              fundId: profilePos?.fundId,
              fundName: profilePos?.longName,
              ticker: profilePos?.ticker,
              isETF: profilePos?.isETF,
              isMutualFund: profilePos?.isMutualFund,
              isClosed: profilePos?.fundFact?.isClosed,
              isClosedToNewInvestors:
                profilePos?.fundFact?.isClosedToNewInvestors,
              isInternalFund: profilePos?.isInternalFund,
              isExternalFund: profilePos?.isExternalFund,
              isFundTransferableToVGI:
                profilePos?.fundFact?.isFundTransferableToVGI,
              isFundAccessFund: profilePos?.fundFact?.isFundAccessFund,
            }
          }
          subscriber.next(this.navTabGroupModel)
          subscriber.complete()
        })
    })
  }
}
